import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { LoginGuard } from './guard/login.guard';
import { FullTextSearchComponent } from './components/dashboard/full-text-search/full-text-search.component';
import { MainLayoutComponent } from './core/components/main-layout/main-layout.component';
import { GraphSearchComponent } from './components/dashboard/graph-search/graph-search.component';
import { TextSearchRasComponent } from './components/dashboard/text-search-ras/text-search-ras.component';
import { UserPageRasComponent } from './modules/user/pages/user-page-ras/user-page-ras.component';
import { AuditoryComponent } from './modules/auditory/main/auditory.component';
import { ForskerComponent } from './components/dashboard/forsker/forsker.component';
import { LogCasesComponent } from './modules/auditory/log-cases/log-cases.component';
import { MainReportsResumeComponent } from './modules/reportResume/main-reports-resume/main-reports-resume.component';
import { UsersConectedComponent } from './components/shared/components/users-conected/users-conected.component';
import { SeeAlertComponent } from './modules/cases/components/alert-content/see-alert/see-alert.component';
import { AlertContentComponent } from './modules/cases/components/alert-content/alert-content.component';
import { WhitoutAssignedCasesComponent } from './modules/cases/components/whitout-assigned-cases/whitout-assigned-cases.component';
import { DashboardAlertsComponent } from './modules/cases-new-view/dashboard-alerts/dashboard-alerts.component';
import { GestionApisComponent } from './gestion-apis/gestion-apis.component';
import { TimerManagementComponent } from './modules/timer-management/timer-management.component';
import { StrikeAlertUserComponent } from './modules/cases/components/strike-alert-user/strike-alert-user.component';
import { ReportCasesComponent } from './modules/cases/components/report-cases/report-cases.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [LoginGuard],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'profile',
        loadChildren: () =>
          import('./modules/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./modules/notification/notification.module').then(
            (m) => m.NotificationModule
          ),
      },
      {
        path: 'licencias',
        loadChildren: () =>
          import('./modules/licencias/licencias.module').then(
            (m) => m.LicenciasModule
          ),
      },
      {
        path: 'units',
        loadChildren: () =>
          import('./modules/unit/unit.module').then((m) => m.UnitModule),
      },
      {
        path: 'unitsView',
        loadChildren: () =>
          import('./modules/unit/unit-ras.module').then((m) => m.UnitRasModule),
      },

      {
        path: 'caseType/:id',
        loadChildren: () =>
          import('./modules/case-types/case-types.module').then(
            (m) => m.CaseTypesModule
          ),
      },
      {
        path: 'caseTypeView/:id',
        loadChildren: () =>
          import('./modules/case-types/case-types-ras.module').then(
            (m) => m.CaseTypesRasModule
          ),
      },

      {
        path: 'roles',
        loadChildren: () =>
          import('./modules/roles/roles.module').then((m) => m.RolesModule),
      },
      {
        path: 'rolesView',
        loadChildren: () =>
          import('./modules/roles/roles-ras.module').then(
            (m) => m.RolesRasModule
          ),
      },

      {
        path: 'users',
        loadChildren: () =>
          import('./modules/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'userView',
        loadChildren: () =>
          import('./modules/user/user-ras.module').then((m) => m.UserRasModule),
      },

      {
        path: 'grupos',
        loadChildren: () =>
          import('./modules/group/group.module').then((m) => m.GroupModule),
        canActivate: [AuthGuard],
      },

      {
        path: 'gruposView',
        loadChildren: () =>
          import('./modules/group/group-ras.module').then(
            (m) => m.GroupRasModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'cases/:id',
        loadChildren: () =>
          import('./modules/cases/cases.module').then((m) => m.CasesModule),
      },
      {
        path: 'rasCases/:id',
        loadChildren: () =>
          import('./modules/cases-ras/cases-ras.module').then(
            (m) => m.CasesRasModule
          ),
      },

      {
        path: 'casesnew/:id',
        loadChildren: () =>
          import('./modules/case-new-view/case-new-view.module').then(
            (m) => m.CaseNewViewModule
          ),
      },

      {
        path: 'newViewCases/:id',
        loadChildren: () =>
          import('./modules/cases-new-view/cases-new-view.module').then(
            (m) => m.CasesNewViewModule
          ),
      },
      {
        path: 'casesArchived/:id',
        loadChildren: () =>
          import('./modules/cases-archived/cases-archived.module').then(
            (m) => m.CasesArchivedModule
          ),
      },
      {
        path: 'casesArchivedRas/:id',
        loadChildren: () =>
          import(
            './modules/cases-archived/cases-archived-ras/cases-archived-ras.module'
          ).then((m) => m.CasesArchivedRasModule),
      },
      {
        path: 'case/:id',
        loadChildren: () =>
          import('./modules/case/case.module').then((m) => m.CaseModule),
      },

      {
        path: 'abstractCase/:id',
        loadChildren: () =>
          import('./modules/abstract-case/abstract-case.module').then(
            (m) => m.AbstractCaseModule
          ),
      },
      {
        path: 'caseRas/:id',
        loadChildren: () =>
          import('./modules/case-ras/case-ras.module').then(
            (m) => m.CaseRasModule
          ),
      },
      {
        path: 'abstractCase/:id',
        loadChildren: () =>
          import('./modules/abstract-case/abstract-case.module').then(
            (m) => m.AbstractCaseModule
          ),
      },
      {
        path: 'resumeRas',
        loadChildren: () =>
          import('./modules/resumeRas/resumeRas-page.module').then(
            (m) => m.ResumeRasPageModule
          ),
      },
      {
        path: 'dashboard/full-text-search',
        component: FullTextSearchComponent,
      },
      {
        path: 'dashboard/ras-search-text',
        component: TextSearchRasComponent,
      },
      {
        path: 'dashboard/graph-search',
        component: GraphSearchComponent,
      },
      {
        path: 'alertInfo/:id',
        component: SeeAlertComponent,
      },
      {
        path: 'alerts/:id',
        component: AlertContentComponent,
      },
      {
        path: 'forsker',
        component: ForskerComponent,
      },
      {
        path: 'auditoria-casos',
        component: AuditoryComponent,
      },
      {
        path: 'log-casos',
        component: LogCasesComponent,
      },

      {
        path: 'informe-productividad',
        component: MainReportsResumeComponent,
      },
      {
        path: 'usuarios-conectados',
        component: UsersConectedComponent,
      },
      {
        path: 'withoutAssigned/:id',
        component: WhitoutAssignedCasesComponent,
      },
      {
        path: 'dashboard-alerts',
        component: DashboardAlertsComponent,
      },
      // gestion de apis
      {
        path: 'gestion-apis',
        component: GestionApisComponent, // Asegúrate de crear este componente
      },
      // configuracion modelo de ia
      {
        path: 'ai-settings',
        loadChildren: () =>
          import('./modules/ai-settings/ai-settings.module').then(
            (m) => m.AiSettingsModule
          ),
      },
      // gestion de timer
      {
        path: 'timer',
        component: TimerManagementComponent,
      },
      // ver strikes por usuarios
      {
        path: 'strike-user/:id',
        component: StrikeAlertUserComponent,
      },
      // reportes
      {
        path: 'reports/:id',
        component: ReportCasesComponent,
      },
    ],
  },
  // ver reporte
  {
    path: 'ReportFileComponent/:id',
    loadChildren: () =>
      import('./modules/case-new-view/ReportFileComponent.module').then(
        (m) => m.ReportFileComponentModule
      ),
    canActivate: [LoginGuard],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
